// src/components/layout/Footer/FooterWrapper.tsx
import React from "react";
import FooterUi from "./FooterUi";

const FooterWrapper: React.FC = () => {
  return <FooterUi />;
};

export default FooterWrapper;
